import {createFeatureSelector, createSelector} from "@ngrx/store";
import {notificationsFeatureKey, NotificationsState} from "../reducers/notifications.reducer";

const notificationsFeatureState = createFeatureSelector<NotificationsState>(notificationsFeatureKey);

export const getNotifications = createSelector(
  notificationsFeatureState,
  state => state.notifications ?? []
);
